Vue.component('event-card-manager', {
    template: templates.eventCardManager,
    props: {
        eventCards: {
          type: Array,
          default: () => []
        },
        temporaryCards: {
          type: Array,
          default: () => []
        },
        availableCards: {
          type: Object,
          default: () => ({})
        },
        abilities: {
            type: Object,
            required: true,
            default: () => ({})
        },
        traits: {
            type: Array,
            default: () => []
        },
        types: {
            type: Object,
            required: true,
            default: () => ({})
        },
        mode: {
          type: String,
          default: 'existing'
        },
        isTeamEnabled: {
            type: Boolean,
            default: false
        },
        battleType: {
            type: String,
            required: true
        },
      },
      data() {
        return {
          cardMode: this.mode,
          temporaryCards: [],
          selectCardMode: false,
          isTeam: false,
          count: 0
        }
      },
      mounted() {
        this.initializeTemporaryCards();
        this.initializeTeamCards();
      },
      methods: {
        setCardMode(mode) {
         
          if(this.selectCardMode){
            this.cardMode = 'temporary';
          }
          else{
            this.cardMode = 'existing';
          }

          if (this.isTeamEnabled) {
            this.ensureTeamCards();
          }

          this.selectCardMode = mode
   
          this.$emit('mode-changed', this.cardMode);
        },
        ensureTeamCards() {

            if (this.cardMode === 'existing') {
              // Ensure 4 existing cards
              
              while (this.eventCards.length < this.count) {
                this.eventCards.push({ cardId: '', tier: 0 });
              }
              // If more than 4, trim to 4
              if (this.eventCards.length > this.count) {
                this.eventCards.splice(this.count);
              }
              this.$emit('cards-updated', this.eventCards);
            } else if (this.cardMode === 'temporary') {
              // Ensure 4 temporary cards
              while (this.temporaryCards.length < this.count) {
                this.addTemporaryCard();
              }
              // If more than 4, trim to 4
              if (this.temporaryCards.length > this.count) {
                this.temporaryCards.splice(this.count);
              }
            }
        },
        addExistingCard() {
          const newCard = { cardId: '', tier: 1 };
          this.eventCards.push(newCard);
          this.$emit('cards-updated', this.eventCards);
        },
        
        removeCard(index) {
          this.eventCards.splice(index, 1);
          this.$emit('cards-updated', this.eventCards);
        },
        
        loadCardStats(card, index) {
          if (card.cardId && this.availableCards[card.cardId]) {
            const cardData = this.availableCards[card.cardId];
            // Optionally populate additional data
            this.$emit('card-selected', { card, index, cardData });
          }
        },
        
        addTemporaryCard() {
            if (this.isTeamEnabled && this.temporaryCards.length >= this.c) {
                return;
            }
            const newCard = {
            id: null,
            baseCardId: '',
            name: '',
            hp: 0,
            pAtk: 0,
            mAtk: 0,
            armor: 0,
            ward: 0,
            speed: 0,
            accuracy: 0,
            critChance: 0,
            critDamage: 150,
            stamina: 1,
            mana: 1,
            type: '',
            ability: '',
            trait: '',
            tier: 1,
            active: 1,
            isModified: false,
            originalStats: null
            };
            this.temporaryCards.push(newCard);
            this.$emit('temporary-cards-updated', this.temporaryCards);
        },
        
        removeTemporaryCard(index) {
            if (this.isTeamEnabled && this.temporaryCards.length <= 4) {
                return;
            }
            this.temporaryCards.splice(index, 1);
            this.$emit('temporary-cards-updated', this.temporaryCards);
        },
        
        toggleModifyMode(card, index) {
          if (!card.isModified) {
            // Reset to create new card
            card.baseCardId = '';
            card.name = '';
            card.hp = 0;
            card.pAtk = 0;
            card.mAtk = 0;
            card.armor = 0;
            card.ward = 0;
            card.speed = 0;
            card.accuracy = 0;
            card.critChance = 0;
            card.critDamage = 150;
            card.stamina = 1;
            card.mana = 1;
            card.type = '';
            card.ability = '';
            card.trait = '';
            card.originalStats = null;
          }
          this.$emit('temporary-cards-updated', this.temporaryCards);
        },
        
        loadBaseCardForModification(card) {
          if (card.baseCardId && this.availableCards[card.baseCardId]) {
            const baseCard = this.availableCards[card.baseCardId];
            
            // Store original stats
            card.originalStats = {
              hp: baseCard.hp,
              pAtk: baseCard.pAtk,
              mAtk: baseCard.mAtk,
              armor: baseCard.armor,
              ward: baseCard.ward,
              speed: baseCard.speed,
              accuracy: baseCard.accuracy,
              critChance: baseCard.critChance,
              critDamage: baseCard.critDamage,
              stamina: baseCard.stamina,
              mana: baseCard.mana
            };

            // Load base card data
            card.name = baseCard.name;
            card.type = baseCard.type;
            card.ability = baseCard.ability;
            card.trait = baseCard.trait;
            card.hp = baseCard.hp;
            card.pAtk = baseCard.pAtk;
            card.mAtk = baseCard.mAtk;
            card.armor = baseCard.armor;
            card.ward = baseCard.ward;
            card.speed = baseCard.speed;
            card.accuracy = baseCard.accuracy;
            card.critChance = baseCard.critChance;
            card.critDamage = baseCard.critDamage;
            card.stamina = baseCard.stamina;
            card.mana = baseCard.mana;
            
            this.$emit('temporary-cards-updated', this.temporaryCards);
          }
        },
        
        initializeTemporaryCards() {
          if (this.temporaryCards.length === 0) {
            this.addTemporaryCard();
          }
        },
        initializeTeamCards() {
          // Initialize team cards based on battle type if team is enabled
          if (this.isTeamEnabled && this.battleType) {
            this.ensureTeamCards();
          }
        }
      },
      watch: {
        mode(newMode) {
          this.cardMode = newMode;
          console.log(newMode)
        },
        isTeamEnabled(newValue) {
            if (newValue) {

            // let count;
            
            // if(this.battleType === '2v2'){
            //     count = 2;
            // }
            // else if(this.battleType === '3v3'){
            //     count = 3;
            // }
            // else if(this.battleType === '4v4'){
            //     count = 4;
            // }
            // else{
            //     count = 1;
            // }

            this.count = 4;
            this.ensureTeamCards();
            }
            else{
                this.count = 0;

                if (this.cardMode === 'existing') {
                    this.eventCards = [{ cardId: null, tier: 0 }]
                }else{
                    this.temporaryCards = []
                }
            }
        }
      }
});